import { useSiteStatsSnapshot } from "./useSiteStatsSnapshot";

/**
 * Returns the live count of episodes, formatted with commas.
 *
 * Backed by `useSiteStatsSnapshot` so this number is ALWAYS identical to
 * the footer's "episodes indexed" stat. The snapshot hook self-heals with
 * a live `count(*)` on `episodes` and uses `Math.max` against the daily
 * snapshot, guaranteeing we always show the highest (most accurate) value.
 *
 * The `fallback` arg is kept for backwards compatibility but no longer
 * used — the snapshot hook has its own fallback.
 */
export function useEpisodeCount(_fallback?: number): { count: number; formatted: string } {
  const { stats, formatted } = useSiteStatsSnapshot();
  return { count: stats.episodes, formatted: formatted.episodes };
}
